export const formStates = {
  PRISTINE: 'PRISTINE',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};
